module.exports = __webpack_public_path__ + "static/media/ManojDeshmukh.db93167a.jfif";